import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ReportInfo } from '../../Models/Models/Reports/ReportInfo';
import { DocumentTaskRequestModel } from '../../Models/Models/Tasks/DocumentTaskRequestModel';

declare var IS_RUNNING_IN_APP_POOL;

export class DocumentTaskRequestClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: DocumentTaskRequestModel): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Tasks/DocumentTaskRequest/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
}

